// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"95028af3","470":"4d36756a"}[chunkId] + ".chunk.js";
};